import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { Link } from "react-router-dom";

var permissions = JSON.parse(localStorage.getItem("permissions"))
? JSON.parse(localStorage.getItem("permissions"))
: [];
function handleCheck(val) {
    return  (permissions ?? []).some(item => val === item.name);
}

export const Navbar = () =>{

  const { t, i18n } = useTranslation();
  
  let user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : false;
  
      return(
          <div>
            <section id="topbar" className="topbar d-flex align-items-center">
              <div className="container d-flex justify-content-center justify-content-md-between">
                <div className="contact-info d-flex align-items-center">
                  <i className="bi bi-envelope d-flex align-items-center" style={{ color : "black"}}><a target="_blank" href="mailto:info@b-eyegroup.net">info@b-eyegroup.net</a></i>
                  <i className="bi bi-whatsapp d-flex align-items-center ms-3" style={{ color : "black"}}><a target="_blank" href="https://wa.me/25767021017"><span>+257 67 021 017</span></a></i>
                  <i className="bi bi-phone d-flex align-items-center ms-3 d-none d-sm-block" style={{ color : "black"}}><a target="_blank" href="tel:+25762503956"><span>+257 62 503 956</span></a></i>
                </div>
                <div className="social-links d-none d-md-flex align-items-center">
                  <a href="https://www.facebook.com/share/1AoQCeKPdE/?mibextid=wwXIfr" className="facebook"><i className="bi bi-facebook" style={{ color : 'white'}}></i></a>
                  <a href="https://www.instagram.com/b.eye.tv?igsh=MWgyaDFpcnh6Y3E4OQ==" className="instagram"><i className="bi bi-instagram" style={{ color : 'white'}}></i></a>
                  <a href="https://www.tiktok.com/@b.eye.tv?_t=ZM-8wfg9Sqm7QT&_r=1" className="tiktok"><i className="bi bi-tiktok" style={{ color : 'white'}}></i></a>
                  <a href="https://x.com/beye2021?s=11" className="twitter"><i className="bi bi-twitter" style={{ color : 'white'}}></i></a>
                </div>
              </div>
            </section>
    
            <header id="header" className="header d-flex align-items-center">

              <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center">
                  <img src="/img/v3.png" alt="" style={{ borderRadius : 80 }} className="p-0 m-0" />
                  <h1 className="p-0 m-0">-EYE</h1>
                </a>
                <nav id="navbar" className="navbar">
                  <ul>
                    <li><a href="/#hero">{t("navbar.home")}</a></li>
                    <li><a href="/#information">{t("navbar.information")}</a></li>
                    <li><a href="/#services">{t("navbar.service")}</a></li>
                    <li><a href="/#portfolio">{t("navbar.blog")}</a></li>

                    { handleCheck("afficher utilisateur") == true && ( <li><Link to="/items">{t("navbar.article")}</Link></li>)}
                    { handleCheck("afficher utilisateur") == true && ( <li><Link to="/staffs">{t("navbar.staff")}</Link></li>)}
                    <li><Link to={ user ? "/profile" : "/login"  }>{ user ? user.name?.slice(0, 4) : ""  }</Link></li>
                    <li className="dropdown"><a href="#"><span className="me-0 p-0 overflow-hidden"><img src={"/img/" + i18n.language  +".jpg"} alt="" height="12" className="m-0 p-0" /></span><i className="bi bi-chevron-down dropdown-indicator"></i></a>
                      <ul className=" p-0" >
                        <li><a  className="p-0 m-0 ps-2 mt-1" href="#" onClick={ () => i18n.changeLanguage("fr")}><span><img src="/img/fr.jpg" alt="" height="15" className="me-2" /><span>Fr</span></span></a></li>
                        <li><a  className="p-0 m-0 ps-2 mt-1" href="#" onClick={ () => i18n.changeLanguage("en")}><span><img src="/img/en.jpg" alt="" height="15" className="me-2" /><span>En</span></span></a></li>
                      </ul>
                    </li>
                  </ul>
                </nav>

                <i className="mobile-nav-toggle mobile-nav-show bi bi-list"></i>
                <i className="mobile-nav-toggle mobile-nav-hide d-none bi bi-x"></i>

              </div>
            </header>
        </div>
        )
    }